import { ReactNode } from 'react'
import './index.less'
import BackgroundBox from '../../BackgroundBox'

const AppraisalFooter = ({ children }: { children: ReactNode }): JSX.Element => {
  return (
    <BackgroundBox rb className="appraisal-footer" data-e2e-appraisal-header-footer>
      {children}
    </BackgroundBox>
  )
}
export default AppraisalFooter
